import React from 'react';
import {connect} from 'react-redux';
import './Ebutton.scss';
import PropTypes from 'prop-types';
import {Tooltip} from '@mui/material';

const Ebutton = (props) => {
    const {
        classNameButton,
        text,
        onClick,
        type,
        disabled,
        tooltipText,
    } = props;

    return ( tooltipText ?
        <Tooltip title={tooltipText}>
            <button
                type={type}
                className={`eb-btn ${classNameButton}`}
                onClick={onClick}
                disabled={disabled}>
                {text}
            </button>
        </Tooltip> :
            <button
                type={type}
                className={`eb-btn ${classNameButton}`}
                onClick={onClick}
                disabled={disabled}>
                {text}
            </button>
    );
};


Ebutton.propTypes = {
    classNameButton: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapDispatchToProps)(Ebutton);

